(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableFloatingLabel =  function (){
      $('input.o-with-floating-label').gnv_floatingLabel();
  };

  $.gnv.floatingLabel = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$el.data("gnv.floatingLabel", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.floatingLabel.defaultOptions, options);

      base.$el.on('focus', function() {
        $(this).addClass('noempty');
      });

      /*base.$el.on('blur', function() {
        if($(this).val() === '')
          $(this).removeClass('noempty');
      });*/

      base.$el.on('focusout', function() {
        if($(this).val() === '')
          $(this).removeClass('noempty');
      });
    };
    base.init();
  };

  $.gnv.floatingLabel.defaultOptions = {};

  $.fn.gnv_floatingLabel = function(options){
    return this.each(function(){
      (new $.gnv.floatingLabel(this, options));
    });
  };

  $.gnv.enableFloatingLabel();

})(jQuery);




